export default __webpack_public_path__ + "static/media/fastingdrink-wide@3x.10ccceb1.jpg";